<template lang="jade">
  .container-fluid.clearfix
    .waitingAni(v-if='showLoadingAni')
      .boxLoading
        span Loading..
    .row
      .edid_main.col-md-12
        header.edid_title_bar.main_title_bar.clearfix
          h1.title.col-md-10.col-sm-10.col-xs-12.clearfix
            |edid
        section
          header.input.col-md-12.clearfix
            h2 Input
          section.col-md-12.col-lg-11.col-centered.edid_group.clear-left
            accordion(type='info')
              panel(v-for='(key, input) in inputs' v-ref:in-panels)
                .panel-title.clearfix(slot='header')
                  .col-xs-2.no_pad.col-md-2
                    h4.no_pad_v.no_margin_v {{key}}.&nbsp;{{inputs[key].name}}
                  .col-xs-1.reload_edid.pull-right
                    i.fa.fa-external-link.fa-lg(v-on:click.stop='asyncLoadInData(key, $event)' v-if="inEDID[key].edid === ''")
                    i.fa.fa-lg(v-on:click.stop='asyncLoadInData(key, $event)'
                      v-else
                      v-bind:class="{'fa-angle-up': inEDID[key].isOpen, 'fa-angle-down': !inEDID[key].isOpen}")
                    //- i.fa.fa-angle-down.fa-lg(v-on:click.stop='asyncLoadInData(key, $event)' v-if="typeof inEDID[key] === 'string' ")
                  .col-xs-1.pull-right.edit_edid.no_pad(v-if="!inEDIDReadonly")
                    i.fa.fa-edit.fa-lg(v-on:click.stop='showModal(key)')
                .col-md-12.col-xs-12.no_pad
                  .edid_trigger
                    edid-displayer(
                      v-on:click='toggleOpen($event)'
                      v-bind:edid-string="inEDID[key].edid")
          header.output.col-md-12.clearfix
            h2 Output
          section.col-md-12.col-lg-11.col-centered.edid_group.clear-left
            accordion(type='info')
              panel(v-for='(key ,output) in outputs' v-ref:out-panels)
                .panel-title.clearfix(slot='header')
                  .col-xs-2.no_pad
                    h4.no_pad_v.no_margin_v {{key}}.&nbsp;{{outputs[key].name}}
                  .col-xs-1.reload_edid.pull-right
                    i.fa.fa-external-link.fa-lg(v-if="outEDID[key].HDMI === '' && outEDID[key].HDBT === ''"
                      v-on:click.stop="asyncLoadOutData(key, outputs[key].type, $event)")
                    i.fa.fa-lg(v-on:click.stop="asyncLoadOutData(key, '', $event)"
                      v-else
                      v-bind:class="{'fa-angle-up': outEDID[key].isOpen, 'fa-angle-down': !outEDID[key].isOpen}")
                  //- .col-xs-1.pull-right.edit_edid.no_pad
                    i.fa.fa-edit.fa-lg(v-on:click.stop="showOutModal(key)" v-if="outEDID[key][outputs[key].type] && outEDID[key][outputs[key].type] !== 'None' && outEDID[key][outputs[key].type] !== 'Loading...'")
                .col-md-12.col-xs-11.no_pad.trigger_group
                  //- 等到hdmi大小寫統一就要拿掉
                  .edid_trigger(v-if="outEDID[key].HDMI && outEDID[key].HDMI !== 'None' ")
                    edid-displayer(
                      v-on:click='toggleOpent($event)'
                      v-bind:edid-string='outEDID[key].HDMI'
                    )
                  .edid_trigger(v-if="outEDID[key].HDBT && outEDID[key].HDBT !== 'None'")
                    edid-displayer(
                      v-on:click='toggleOpen($event)'
                      v-bind:edid-string='outEDID[key].HDBT')
                  .edid_trigger(v-if="outEDID[key].HDBT === 'None' || outEDID[key].HDMI === 'None'")
                    span {{outEDID[key].HDBT === 'None' ? outEDID[key].HDBT : outEDID[key].HDMI}}
    modal(v-bind:title.sync='outModal.title'
          v-bind:show.sync='showOutConfig'
          v-bind:callback='handleOutConfig'
          effect:zoom
          backdrop='false'
          ok-text='Apply'
          cancel-text='Cancel').out_edid_config
          .modal-body.clearfix(slot='modal-body')
            .col-xs-12
              .col-xs-4.col-md-3.no_pad
                label Learn EDID to
              .col-xs-6.col-md-4
                v-select(v-bind:options='outModal.options' v-bind:value.sync='outModal.option')
    modal(v-bind:title.sync="editing.title"
          v-bind:show.sync="showConfig"
          v-bind:callback="handleApply"
          effect:zoom
          backdrop='false'
          ok-text="Apply"
          cancel-text="Cancel").edid_config
          .modal-body.clearfix(slot='modal-body')
            table.table.table-bordered.table-striped.table-hover
              tr
                th EDID
                td
                  span.col-xs-12.no_pad.clearfix
                    .fa_checkbox
                      input(type='radio' id='default' value='default' name='method' v-model='editing.edidMethod')
                      label(for='default')
                        span Default
                    .col-md-12.clearfix.input_single.no_pad(v-if="editing.edidMethod === 'default'")
                      v-select.outputBtn(v-bind:options='defaultEDIDoptions' v-bind:value.sync='editing.buildInValue' placeholder='Select a default EDID')
                    .fa_checkbox
                      input(type='radio' id='output' value='output' name='method' v-model='editing.edidMethod')
                      label(for='output')
                        span Output
                    .col-md-12.clearfix.input_single(v-if="editing.edidMethod === 'output'")
                      v-select(v-bind:options='outOptions' v-bind:value.sync='editing.outValue' placeholder='Port' v-bind:disabled='outOptions.length === 0')
                      //- label.col-xs-12.no_pad Type
                      v-select.col_space--xxs(v-bind:options="outTypes[editing.outValue]"
                               v-bind:value.sync='editing.outType'
                               v-bind:disabled="!outTypes[editing.outValue] || outTypes[editing.outValue].length === 0"
                               placeholder='type')
                    .fa_checkbox
                      input(type='radio' id='custom' value='custom' name='method' v-model='editing.edidMethod')
                      label(for='custom')
                        span Customize File
                    .fa_checkbox(v-if='supportAutoEDID')
                      input(type='radio' id='auto' value='auto' name='method' v-model='editing.edidMethod')
                      label(for='auto')
                        span Auto
                    .col-md-12.clearfix.input_single(v-if="editing.edidMethod === 'custom'")
                      label#fileBtn(for='file').btn.btn-default {{uploadFileBtnText}}
                      input#file.form-control(type='file' v-el:edidbin v-on:change="checkFile($event)")
</template>

<script>
import { modal, accordion } from 'vue-strap'
import panel from 'src/components/Edid-panel.vue'
import select from 'src/components/Single-Select.vue'
import { call } from 'src/Service.js'
import _ from 'lodash'
import $ from 'jquery'
import EdidDisplayer from './EdidDisplayer.vue'

export default {
  components: {
    modal,
    accordion,
    panel,
    'v-select': select,
    'edid-displayer': EdidDisplayer
  },
  data () {
    return {
      showOutConfig: false,
      outModal: {
        title: '',
        _id: '',
        options: [],
        option: '1'
      },
      showLoadingAni: false,
      oneAtATime: true,
      access: '',
      supportAutoEDID: false,
      inEDIDReadonly: false,
      inputs: {},
      outputs: {},
      inEDID: {},
      outEDID: {},
      defaultEDIDoptions: [],
      outOptions: [],
      outTypes: [],
      editing: {
        title: '',
        _id: '',
        type: '',
        edidMethod: '',
        buildInValue: '',
        fileIsAvilable: false,
        hexValue: '',
        outValue: '',
        outType: ''
      },
      showConfig: false,
      uploadFileBtnText: 'Click to upload file',
      hexString: ''
    }
  },
  asyncData () {
    let { mac } = this.$route.params
    call(mac, 'dxGetAbout').then(({capability}) => {
      console.log('capability', capability)
      this.access = capability.edid.access
      this.supportAutoEDID = capability.edid.supportAutoEDID || false
      this.inEDIDReadonly = capability.edid.inputs === 'ro'
      return call(mac, 'dxGetEDIDOptions')
    }).then((res) => {
      // console.log('dxGetEDID option', res)
      this.defaultEDIDoptions = res.default.map(obj => {
        return {
          label: obj.name,
          value: obj.value
        }
      })

      return call(mac, 'dxGetPortInfo')
    }).then(({inputs, outputs}) => {
      // console.log('inputs', inputs)
      // console.log('ouputs', outputs)
      this.inputs = inputs
      this.outputs = outputs
      this.outModal.options = []
      for (let key in outputs) {
        this.outEDID[key] = {
          isOpen: false,
          HDBT: '',
          HDMI: ''
        }
      }
      for (let key in inputs) {
        this.inEDID[key] = {
          edid: '',
          isOpen: false
        }
        this.outModal.options.push({
          label: 'Input' + key,
          value: key
        })
      }
      // this.outModal.options.push({ // release it after new API is done
      //   label: 'All',
      //   value: 'all'
      // })
      if (this.$route.name === 'matrix') {
        return call(mac, 'dxGetMatrixStatus')
      } else if (this.$route.name === 'mixer') {
        return call(mac, 'dxGetMixerStatus')
      }
    }).then(({links}) => {
      let outputs = _.cloneDeep(this.outputs)
      for (let key in outputs) {
        outputs[key] = _.assignIn(outputs[key], {link: links.outputs[key]})
      }
      this.outputs = _.cloneDeep(outputs)
      if (this.access === 'multiple') {
        return call(mac, 'dxGetEDID')
      } else {
        // @@ToDo: Support access === 'single'
        return this.alert('danger', '', 'not support single EDID yet')
      }
    })
    .then(({outputs}) => {
      console.log('getEDID outputs', outputs)
      this.outOptions = []
      this.outTypes = []
      Object.keys(outputs).map(key => { // key = [1,2,3,4......]
        if (this.outputs[key].link) {
          this.outOptions.push({
            label: key,
            value: key
          })

          this.outTypes[key] = []
          if (outputs[key].HDMI) {
            this.outTypes[key].push({
              label: 'HDMI',
              value: 'HDMI'
            })
          }
          if (outputs[key].HDBT) {
            this.outTypes[key].push({
              label: 'HDBT',
              value: 'HDBT'
            })
          }
        }
      })
    }).catch(err => {
      this.alert('danger', '', err)
      this.reloadAsyncData()
    })
  },
  methods: {
    toggleOpen (e) {
      let target = e.target
      if (!$(target).is('a')) {
        target = target.parentNode
      }
      if ($(target).hasClass('open')) {
        $(target).removeClass('open')
      } else {
        $(target).addClass('open')
      }
    },
    alert (type, title, content) {
      this.$dispatch('alert', {
        type: type,
        title: title,
        content: content
      })
    },
    showOutModal (key) {
      this.outModal.title = 'Output ' + key
      this.outModal._id = key
      this.showOutConfig = true
    },
    handleOutConfig () {
      console.log('handle outConfig')
      this.showLoadingAni = true
      let outKey = this.outModal._id
      let { mac } = this.$route.params
      let params = {
        inputs: {}
      }
      if (this.outModal.option && this.outModal.option === 'all') {
        for (let inKey in this.inputs) {
          params.inputs[inKey] = {
            type: this.outputs[outKey].type,
            value: outKey
          }
        }
      } else if (this.outModal.option) {
        params.inputs = {
          [this.outModal.option]: {
            type: this.outputs[outKey].type,
            value: outKey
          }
        }
      } else {
        return this.alert('danger', '', 'Please select a valid option')
      }
      console.log(params)
      call(mac, 'dxSetEDID', params).then(res => {
        setTimeout(() => {
          console.log(res)
          this.showLoadingAni = false
          this.showOutConfig = false
        }, 2000)
      }, err => {
        this.alert('danger', '', err)
        this.showLoadingAni = false
      })
    },
    showModal (key) {
      this.editing.edidMethod = ''
      this.editing._id = key
      this.editing.type = this.inputs[key].type
      this.editing.title = 'Input ' + key + ' EDID config'
      this.editing.outValue = ''
      this.editing.outType = this.outputs[key] ? this.outputs[key].type : this.outputs['1'].type
      this.editing.buildInValue = ''
      this.showConfig = true
    },
    asyncLoadInData (key, e) {
      console.log('hahaha load inEDID')
      if (this.inEDID[key].edid !== '') {
        $(e.target).parents('.panel').find('.edid_trigger').addClass('open')
        this.$refs.inPanels[key].isOpen = !this.$refs.inPanels[key].isOpen
        this.inEDID[key].isOpen = !this.inEDID[key].isOpen
        return
      }
      this.showLoadingAni = true
      let { mac } = this.$route.params
      call(mac, 'dxGetEDID', {
        inputs: key,
        type: this.inputs[key].type
      }).then(({inputs}) => {
        console.log(inputs[key])
        setTimeout(() => {
          // assign the new value
          let newEDID = _.cloneDeep(this.inEDID)
          newEDID = _.assignIn(newEDID, {
            [key]: {
              isOpen: false,
              edid: inputs[key]
            }
          })
          // newEDID[key] = parseEDID(inputs[key])
          this.inEDID = newEDID
          // open the panel and .edid_trigger
          $(e.target).parents('.panel').find('.edid_trigger').addClass('open')
          this.$refs.inPanels[key].isOpen = true
          this.inEDID[key].isOpen = true
          this.showLoadingAni = false
        }, 2000)
      }).catch(err => {
        this.alert('danger', '', err)
        this.showLoadingAni = false
      })
    },
    asyncLoadOutData (key, type, e) {
      console.log('asyncLoadOutData', key, type)
      let { mac } = this.$route.params

      // show the loading.. msg
      console.log('start to load the outEDID')
      if (type === '') {
        this.$refs.outPanels[key].isOpen = !this.$refs.outPanels[key].isOpen
        this.outEDID[key].isOpen = !this.outEDID[key].isOpen
        return
      }
      this.showLoadingAni = true

      // call the API and set value to this.outEDID
      if (type !== 'combo') {
        call(mac, 'dxGetEDID', {
          outputs: key,
          type: type
        }).then(({outputs}) => {
          setTimeout(() => {
            let newEDID = _.cloneDeep(this.outEDID)
            if (outputs[key]) {
              _.setWith(newEDID, `[${key}]`, outputs[key])
            } else {
              _.setWith(newEDID, `[${key}]['HDMI']`, 'None')
              _.setWith(newEDID, `[${key}]['HDBT']`, 'None')
            }
            this.outEDID = _.cloneDeep(newEDID)

            // open the panel and .edid_trigger
            $(e.target).parents('.panel').find('.edid_trigger').addClass('open')
            this.$refs.outPanels[key].isOpen = true
            this.outEDID[key].isOpen = true
            this.showLoadingAni = false
          }, 2000)
        }).catch(err => {
          this.alert('danger', '', err)
          this.showLoadingAni = false
        })
      } else {
        call(mac, 'dxGetEDID', {
          outputs: key,
          type: 'HDMI'
        }).then(({outputs}) => {
          let newEDID = _.cloneDeep(this.outEDID)
          if (outputs[key]) {
            _.setWith(newEDID, `[${key}][HDMI]`, outputs[key].HDMI)
          } else {
            _.setWith(newEDID, `[${key}][HDMI]`, 'None')
          }
          console.log('new EDID', newEDID)
          this.outEDID = _.cloneDeep(newEDID)

          return call(mac, 'dxGetEDID', {
            outputs: key,
            type: 'HDBT'
          })
        }).then(({outputs}) => {
          console.log(outputs)
          setTimeout(() => {
            let newEDID = _.cloneDeep(this.outEDID)
            if (outputs[key]) {
              _.setWith(newEDID, `[${key}][HDBT]`, outputs[key].HDBT)
            } else {
              _.setWith(newEDID, `[${key}][HDBT]`, 'None')
            }
            console.log('new EDID', newEDID)
            this.outEDID = _.cloneDeep(newEDID)
            this.showLoadingAni = false
            // open the panel and .edid_trigger
            $(e.target).parents('.panel').find('.edid_trigger').addClass('open')
            this.$refs.outPanels[key].isOpen = true
            this.outEDID[key].isOpen = true
          }, 2000)
        }).catch(err => {
          this.alert('danger', '', err)
          this.showLoadingAni = false
        })
      }
    },
    hasValidExtension (e) {
      // filter some invalid extension
      let fileName = e.target.files[0].name
      let extension = fileName.split('.')[fileName.split('.').length - 1].toLowerCase()
      if (extension === 'bin') {
        return true
      } else {
        return false
      }
    },
    detectIE () {
      let ua = window.navigator.userAgent
      // Test values; Uncomment to check result …

      // IE 10
      // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

      // IE 11
      // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

      // Edge 12 (Spartan)
      // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

      // Edge 13
      // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

      let msie = ua.indexOf('MSIE ')
      if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10)
      }

      let trident = ua.indexOf('Trident/')
      if (trident > 0) {
        // IE 11 => return version number
        let rv = ua.indexOf('rv:')
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
      }

      let edge = ua.indexOf('Edge/')
      if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10)
      }

      // other browser
      return false
    },
    checkFile (e) {
      this.editing.fileIsAvilable = false
      let { files } = this.$els.edidbin

      if (files.length === 0) return this.alert('danger', '', 'file.length === 0')
      if (!this.hasValidExtension(e)) {
        this.alert('danger', '', 'Please upload a valid file(.bin)')
        this.uploadFileBtnText = 'Click to upload file'
        return
      }

      if (this.detectIE()) { // for IE
        console.log('revise readAsBinaryString of IE')
        // use this.hesString as a global variable to pass the hexValue
        let vue = this
        window.FileReader.prototype.readAsBinaryString = function (fileData) {
          let binary = ''
          let pt = this
          let reader = new window.FileReader()
          reader.onload = function (e) {
            let bytes = new Uint8Array(reader.result)
            let length = bytes.byteLength
            for (let i = 0; i < length; i++) {
              binary += String.fromCharCode(bytes[i])
            }
            // pt.result  - readonly so assign binary
            pt.content = binary
            for (let i = 0; i < pt.content.length; i++) {
              let uint = pt.content.charCodeAt(i)
              vue.hexString += uint < 16 ? `0${uint.toString(16)}` : uint.toString(16)
            }
            vue.uploadFileBtnText = files[0].name
            $(pt).trigger('onload')
          }
          reader.readAsArrayBuffer(fileData)
        } // end of the new FileReader()
        let freader = new window.FileReader()
        freader.readAsBinaryString(files[0])
        console.log(this.hexString)
        console.log(this.hexString.length)
        if (this.hexString.length !== 512) return this.alert('danger', '', 'Invalid EDID')
        // only validate length temporarily
        this.editing.hexValue = this.hexString
        this.hexString = ''
        this.editing.fileIsAvilable = true
      } else { // for none IE
        let freader = new window.FileReader()
        let hexString = ''
        freader.readAsBinaryString(files[0])
        freader.onload = () => {
          for (let i = 0; i < freader.result.length; i++) {
            let uint = freader.result.charCodeAt(i)
            hexString += uint < 16 ? `0${uint.toString(16)}` : uint.toString(16)
          }
          console.log('result hex string = ', hexString)
          this.uploadFileBtnText = files[0].name
        }
        if (hexString.length !== 512) return this.alert('danger', '', 'Invalid EDID')
        // only validate length temporarily
        console.log(hexString.length)
        this.editing.hexValue = hexString
        this.editing.fileIsAvilable = true
      }
    },
    handleApply () {
      if (!this.editing.edidMethod) {
        this.alert('danger', '', 'Please pick where you want to set EDID from')
        return
      }
      this.showLoadingAni = true
      let { mac } = this.$route.params
      let params = {}
      switch (this.editing.edidMethod) {
        case 'default':
          if (!this.editing.buildInValue) {
            this.showLoadingAni = false
            this.alert('danger', '', 'Please select a default edid.')
            return
          }
          params = {
            inputs: {
              [this.editing._id]: {
                type: 'default',
                value: this.editing.buildInValue
              }
            }
          }
          break
        case 'output':
          if (!this.editing.outValue) {
            this.showLoadingAni = false
            this.alert('danger', '', 'Please select an output EDID.')
            return
          }
          if (this.editing.outValue && this.outTypes[this.editing.outValue].length === 0) {
            this.showLoadingAni = false
            this.alert('danger', '', 'The port you pick is not available.')
            return
          }
          if (!this.editing.outType) {
            this.showLoadingAni = false
            this.alert('danger', '', 'Please select an output EDID type.')
            return
          }
          params = {
            inputs: {
              [this.editing._id]: {
                type: this.editing.outType,
                // type: 'output',
                value: this.editing.outValue
              }
            }
          }
          break
        case 'custom':
          if (!this.editing.fileIsAvilable) {
            this.showLoadingAni = false
            this.alert('danger', '', 'Please make sure your file has valid EDID.')
            return
          }
          params = {
            inputs: {
              [this.editing._id]: {
                type: 'custom',
                value: this.editing.hexValue
              }
            }
          }
          console.log(params)
          break
        case 'auto':
          params = {
            inputs: {
              [this.editing._id]: {
                type: 'auto'
              }
            }
          }
          break
      }
      // console.log(params)
      call(mac, 'dxSetEDID', params).then(res => {
        // @Todo: callback
        setTimeout(() => {
          console.log('hahah response')
          console.log(res)
          this.showLoadingAni = false
          this.showConfig = false
        }, 2000)
      }).catch(err => {
        this.alert('danger', 'Error', err)
        this.showLoadingAni = false
      })
    }
  },
  watch: {
    'editing.edidMethod' (nV) {
      this.editing.outType = ''
    },
    'outModal.option' (nV) {
      console.log(nV)
    },
    'showConfig' (nV) {
      if (!nV) {
        this.uploadFileBtnText = 'Click to upload file'
        this.editing.fileIsAvilable = false
      }
    }
  },
  events: {
    update (mac, {type, event, msg}) {
      if (type === 'edid') {
        console.log(type)
        console.log(event)
        let obj = _.cloneDeep(this.inEDID)
        obj = _.assignIn(obj, event.inputs)
        this.inEDID = obj
        this.reloadAsyncData()
      } else if (type === 'links') {
      }
    }
  },
  ready () {
    // add FileReader.readAsBinaryString function in IE11
    if (window.FileReader.prototype.readAsBinaryString === undefined) {
      window.FileReader.prototype.readAsBinaryString = function (fileData) {
        let binary = ''
        let pt = this
        let reader = new window.FileReader()
        let data
        reader.onload = function (e) {
          if (!e) {
            data = reader.content
          } else {
            data = e.target.result
          }
          let bytes = new Uint8Array(data)
          let length = bytes.byteLength
          for (let i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i])
          }
          // pt.result  - readonly so assign content to another property
          pt.content = binary
          pt.onload()
        }
        reader.readAsBinaryString(fileData)
      }
    }
    // console.log(parseEDID('00FFFFFFFFFFFF0035341520000000010119010480342178EEEE91A3544C99260F5054BFEF80A940A9C0B30095008BC08140810081C004740030F2705A80B0588A00C48E2100001E283C80A070B0234030203600C48E2100001A000000FC0048444D49204D61747269780A20000000FD00384C1E5311010A20202020202001760203587157E15F101F20212205140413120316075D5E6062636465663B097F070F7F071707503F14C04D02005704005F7E005F7E01675400834F000078030C001000387820C00E014107DC40204620782090209620E20F0104740030F2705A80B0588A00C48E2100001E023A801871382D40582C4500C48E2100001E0000006B'))
  }
}
</script>

<style lang='scss' scoped>
@import '~__vendor_variables_scss__';
@import '~sass/_breakpoint.scss';

.panel-title{
  font-size: 18px;
  @include breakpoint(xxs){
    font-size: 16px;
  }
  h4{
    font-size: 18px;
    @include breakpoint(xxs){
      font-size: 16px;
    }
  }
}
.edid_config{
  .input_single{
    padding-bottom: $space_xxs;
  }
  & th{
    text-align: center;
  }
}
.edid_trigger{
  width: 100%;
  overflow-x: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  white-space: nowrap;
  & *{
    cursor: pointer;
  }
  & label{
    font-size: 16px;
    @include breakpoint(xxs){
      font-size: 14px;
    }
  }
  :hover{
    color: $pri_dark;
    text-decoration: none;
  }
  .open {
    color: $pri_dark;
    text-decoration: none;
    display: block;
    white-space: normal;
    text-overflow: clip;
    /* These are technically the same, but use both */
    overflow-wrap: break-word;
    word-wrap: break-word;
    -ms-word-break: break-all;
    /* Instead use this non-standard one: */
    word-break: break-word;
  }
}
.elli{
  text-overflow: ellipsis;
}
.edid_group{
  .edit_edid{
    text-align: center;
    @include breakpoint(md){
      text-align: right;
    }
    @include breakpoint(lg){
      text-align: right;
    }
  }
  .reload_edid{
    text-align: center;
  }
}
.edid__single{
  > div {
    border: 1px solid $base_gray;
    padding: 3px 10px;
  }
}

#file{
  position: absolute;
  left: -9999px;
}



/* EDID waiting Animation */
.container-fluid{
  position: relative;
}
.waitingAni{
  z-index: 1051;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  background-color: rgba(0, 0, 0, .3);

  & .boxLoading {
    & span{
      color: #fff;
      font-size: 14px;
      text-align: center;
      width: 100%;
      display: inline-block;
      margin-top: 10px;
    }
    padding-top: 80px;
    z-index: 1000;
    width: 100px;
    height: 100px;
    margin: auto;
    position: absolute;
    left: 0;
    right: 0;
    top: -50px;
    bottom: 0;
    &:before {
      content: '';
      width: 50px;
      height: 5px;
      background: #000;
      opacity: 0.1;
      position: absolute;
      top: 85px;
      left: 25px;
      border-radius: 50%;
      animation: shadow .5s linear infinite;
    }
    &:after {
      content: '';
      width: 50px;
      height: 50px;
      background: #1A6844;
      animation: animate .5s linear infinite;
      position: absolute;
      top: 25px;
      left: 25px;
      border-radius: 3px;
    }
  }

  @keyframes animate {
    17% {
      border-bottom-right-radius: 3px;
    }
    25% {
      transform: translateY(9px) rotate(22.5deg);
    }
    50% {
      transform: translateY(18px) scale(1, .9) rotate(45deg);
      border-bottom-right-radius: 40px;
    }
    75% {
      transform: translateY(9px) rotate(67.5deg);
    }
    100% {
      transform: translateY(0) rotate(90deg);
    }
  }


  @keyframes shadow {
    0%, 100% {
      transform: scale(1, 1);
    }
    50% {
      transform: scale(1.2, 1);
    }
  }
}
/* end of waiting ani */
</style>



// WEBPACK FOOTER //
// Edid.vue?7e2c898c